import { CnResult as UiCnResult } from '@/components/cn-result';
import { connect, mapProps } from '@formily/react';
import { mapSize, mapStatus } from '../__builtins__';
export var CnResult = connect(UiCnResult, mapProps(mapSize, mapStatus));
